<template>
    <div>
        <div v-if="!requisicoes.finalizado" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        
        <div v-if="requisicoes.finalizado" class="space-y-8">
            <section class="form-section" v-if="this.nomeEmpresa != 'ACTUAL' || (this.nomeEmpresa == 'ACTUAL' && this.Edicao == true)">
                <div class="form-section-header">
                    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Produtos</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                        Preencha o questionário Suitability para ter acesso aos melhores produtos de acordo com o seu perfil.
                    </p>
                </div>
                
                <div class="form-section-content" v-if="produtosFiltrados && produtosFiltrados.length > 0">
                    <!-- Desktop Table -->
                    <div class="hidden md:block border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden">
                        <table class="w-full">
                            <thead class="bg-gray-50 dark:bg-slate-800">
                                <tr>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                                        Nome do produto
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                                        CNPJ
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                                        Perfil
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                                        Vigência
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700">
                                <tr v-for="(produto, index) in produtosFiltrados" :key="index" class="hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors">
                                    <td class="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                                        {{produto.Descricao}}
                                    </td>
                                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                                        {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : ''}}
                                    </td>
                                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                                        {{produto.PerfilNome}}
                                    </td>
                                    <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                                        {{produto.Vigencia > 0 ? produto.Vigencia : 'Não se aplica'}}
                                    </td>
                                    <td class="px-4 py-3 text-sm">
                                        <div class="flex gap-2">
                                            <button 
                                                v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa != 'ACTUAL')" 
                                                @click="lerTermos(produto.ProdutoId)"
                                                class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors">
                                                Ler os termos
                                            </button>

                                            <button 
                                                v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa == 'ACTUAL')" 
                                                @click="lerTermos(produto.ProdutoId)"
                                                class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors">
                                                Pendente de assinatura
                                            </button>

                                            <button 
                                                v-if="listaProdutosCliente.some(p => p.ProdutoId == produto.ProdutoId && p.Aceite == true)" 
                                                disabled
                                                class="px-3 py-1.5 text-xs font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75">
                                                Produto Adquirido
                                            </button>

                                            <button 
                                                v-if="listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true)"  
                                                @click="visualizarTermos(produto.ProdutoId)"
                                                class="px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors">
                                                Ver mais
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Mobile Cards -->
                    <div class="md:hidden space-y-3">
                        <template v-for="(produto, index) in produtosFiltrados" :key="index">
                            <div v-if="produto.Descricao" class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 space-y-3 bg-white dark:bg-slate-800">
                                <div>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descrição</p>
                                    <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
                                        {{ produto.Descricao }}
                                    </p>
                                </div>

                                <div>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">CNPJ</p>
                                    <p class="text-sm text-gray-700 dark:text-gray-300">
                                        {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : "" }}
                                    </p>
                                </div>

                                <div>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Perfil</p>
                                    <p class="text-sm text-gray-700 dark:text-gray-300">
                                        {{ produto.PerfilNome }}
                                    </p>
                                </div>

                                <div>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Vigência</p>
                                    <p class="text-sm text-gray-700 dark:text-gray-300">
                                        {{ produto.Vigencia > 0 ? produto.Vigencia : "Não se aplica" }}
                                    </p>
                                </div>

                                <div class="flex flex-col gap-2 pt-2">
                                    <button
                                        v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa != 'ACTUAL')"
                                        @click="lerTermos(produto.ProdutoId)"
                                        class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors">
                                        Ler os termos
                                    </button>

                                    <button
                                        v-if="(!listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true) && this.nomeEmpresa == 'ACTUAL')"
                                        @click="lerTermos(produto.ProdutoId)"
                                        class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors">
                                        Pendente de assinatura
                                    </button>

                                    <button
                                        v-if="listaProdutosCliente.some(p => p.ProdutoId == produto.ProdutoId && p.Aceite == true)"
                                        disabled
                                        class="w-full px-4 py-2 text-sm font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75">
                                        Produto Adquirido
                                    </button>

                                    <button
                                        v-if="listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId && produtoCliente.Aceite == true)"
                                        @click="visualizarTermos(produto.ProdutoId)"
                                        class="w-full px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors">
                                        Ver mais
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </section>

            <ModalQuestionario />
            <ModalProdutos />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalQuestionario  from '../Questionario/ModalQuestionario.vue'
import ModalProdutos  from '../Produtos/ModalInformativoProdutos.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'
export default {
    name: 'CadastroFI_Produtos',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
      components: { ModalQuestionario, ModalProdutos },
      computed: {
        ...mapGetters({
            user: 'auth/user',
            listaProdutos: 'GET_LISTA_PRODUTOS',
            perfilCliente: 'GET_PERFIL_CLIENTE',
            listaProdutosCliente: 'GET_LISTA_PRODUTOS_CLIENTE',
            configDispensaQuestionario: 'GET_DISPENSA_QUESTIONARIO'
        }),
        produtosFiltrados() {
            if(this.nomeEmpresa != 'ACTUAL'){
              return this.listaProdutos;
            }else if(this.nomeEmpresa == 'ACTUAL' && !this.Edicao){
              return [];
            }else if(this.nomeEmpresa == 'ACTUAL' && this.Edicao){
              return this.listaProdutos?.filter(produto =>
                this.listaProdutosCliente.some(produtoCliente => produtoCliente.ProdutoId === produto.ProdutoId)
              )
            }else{
              return [];
            }
        },
    },
    data() {
      return{
            requisicoes: {
              listaProdutos: false,
              perfilCliente: false,
              listaProdutosCliente: false,
              configDispensaQuestionario: false,
              finalizado: false
            },
            bloquearDispensaQuestionario: false,
            permitirAvancar: true,
            nomeEmpresa: '',
            dadosUsuario: {
              PerfilRisco: ''
            },
            produtosCliente: [],
      }
    },
    created(){
      this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');
      this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
      this.$store.dispatch('FETCH_PERFIL_CLIENTE');
      this.$store.dispatch('FETCH_VERIFICAR_DISPENSA_QUESTIONARIO');
    },
    mounted(){
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.verificarConfigDispensaQuestionario();
        this.verificarPerfilCliente();
        this.verificarSeRequisicoesFinalizaram('listaProdutos');
        if(this.listaProdutosCliente != null){
          this.produtosCliente = this.listaProdutosCliente;
        }
        this.verificarSeRequisicoesFinalizaram('listaProdutosCliente')

        this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
    },
    watch: {
       configDispensaQuestionario(){
        this.verificarConfigDispensaQuestionario();

      },
      listaProdutosCliente(){
        if(this.listaProdutosCliente != null){
          this.produtosCliente = this.listaProdutosCliente;
        }
        this.verificarSeRequisicoesFinalizaram('listaProdutosCliente');
      },
      perfilCliente(){
        this.verificarPerfilCliente();
      },
      listaProdutos(){
          this.verificarSeRequisicoesFinalizaram('listaProdutos');
      }
    },
    methods: {
      verificarPerfilCliente(){
         this.verificarSeRequisicoesFinalizaram('perfilCliente');
          if(this.perfilCliente)
            if(this.perfilCliente[0])
              this.dadosUsuario = this.perfilCliente[0];
              this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');
              this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
      },
      verificarConfigDispensaQuestionario(){
          if(this.configDispensaQuestionario != null){
          var configuracaoDispensa = this.configDispensaQuestionario.filter(config =>
              config.Chave == 'Dispensa do questionário'
          );

          if(configuracaoDispensa[0] != null){
            if(configuracaoDispensa[0].Valor == 'Não'){
                this.bloquearDispensaQuestionario = true;
            }
          }

        }

        this.verificarSeRequisicoesFinalizaram('configDispensaQuestionario');
      },
      verificarSeRequisicoesFinalizaram(requisicao){
        if(requisicao == 'listaProdutos')
        {
          this.requisicoes.listaProdutos = true;
        }else if(requisicao == 'perfilCliente')
        {
          this.requisicoes.perfilCliente = true;
        }else if(requisicao == 'listaProdutosCliente')
        {
          this.requisicoes.listaProdutosCliente = true;
        }else if(requisicao == 'configDispensaQuestionario')
        {
          this.requisicoes.configDispensaQuestionario = true;
        }

        if((this.requisicoes.listaProdutos && this.requisicoes.perfilCliente && this.requisicoes.listaProdutosCliente && this.requisicoes.configDispensaQuestionario) ||  this.nomeEmpresa == 'ACTUAL'){
          this.requisicoes.finalizado = true;
        }
      },
      abrirQuestionario(){
        this.$store.commit("SET_MODAL_QUESTIONARIO", true);
      },
      lerTermos(id){
        this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
      },
      visualizarTermos(id){
          this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
          this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
      },
      validarForm(){
          this.permitirAvancar = true;
      },
      validarFormulario() {
        this.permitirAvancar = true;
        return this.permitirAvancar;
      },
      proximaEtapa(){
        this.validarForm();
        if(this.permitirAvancar){
          this.$store.commit('SET_FICHA_CONCLUIR', true);
          this.salvarInformacoes();
        }
      },
       salvarInformacoes(){
        this.$store.commit('SET_FI_SALVAR_INFO', true);
      },
    }
}

</script>

<style lang="scss" scoped>
</style>